import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import recoveryService from "@/core/services/RecoveryService";

@Module
export default class RecoveryModule extends VuexModule {
  page: any = {
    data: [],
    total: 0,
    totalPages: 0
  }

  @Action
  [Actions.LOAD_RECOVERIES](filter) {
    this.context.commit(Mutations.SET_SEARCH_LOADING, true)
    recoveryService.findAll(filter).then(res => {
      this.context.commit(Mutations.SET_RECOVERIES, res)
    }).finally(() => {
      this.context.commit(Mutations.SET_SEARCH_LOADING, false)
    })
  }

  @Mutation
  [Mutations.SET_RECOVERIES](data) {
    this.page = data
  }
}